import { isRef } from "vue";
import type { Ref } from "vue";

/**
 * @function set - set a ref value
 * @param {Ref<ValueType> | ValueType} targetRef - possible ref to set
 * @param {ValueType} targetValue - value to set
 */
export default function set<ValueType>(
  targetRef: Ref<ValueType> | ValueType,
  targetValue: ValueType
): void {
  if (isRef(targetRef)) {
    targetRef.value = targetValue;
  } else {
    targetRef = targetValue;
  }
}
